var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEquilateralRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 81,
    viewBox: "0 0 71 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2.13965L35 17.1396L55 28.6396L65.5 34.6396L68 36.1396L69.0548 37.1396L70.0274 38.1396L70.5137 39.1396L71 40.1396V40.6396V41.1396L70.5137 42.1396L70.0274 43.1396L69.0548 44.1396L34.5 64.1396L16.5 74.6396L8.5 79.1396L6 80.1396H4L1.5 78.6396L0.5 76.6396L0 75.1396V35.6396V15.8896V6.01465V4.5V3.5L0.5 2.5L1.5 1.5L2.5 1L3.5 0.639648H5L7 1.13965L9 2.13965Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquilateralRight);
export default __webpack_public_path__ + "static/media/Equilateral_Right.acd09adebf4ace551841e5e915e02f6e.svg";
export { ForwardRef as ReactComponent };